import { SyntheticEvent } from 'react';
import { ShortMediaInfo } from '@shared/types';
import './MediaInfo.scss'
import { TRANSPARENT_POSTER } from './MediaInfo';

interface MediaInfoProps {
  media: ShortMediaInfo;
  className?: string;
}

const MediaInfoLite = ({ media, className }: MediaInfoProps) => {
  const handleOnPosterError = (e: SyntheticEvent<HTMLImageElement>) => {
    (e.target as HTMLImageElement).src=TRANSPARENT_POSTER;
    (e.target as HTMLImageElement).className = 'no-poster';
  };

  return (
    <div className={'media-info' + (className ? ` ${className}` : '')}>
      <div className="poster-wrapper">
        <img src={media.poster || TRANSPARENT_POSTER} className={media.poster ? '' : 'no-poster'}
             onError={handleOnPosterError}/>
      </div>
      <dl>
        <dt title={media.title}>{media.title}</dt>
        {(media.tag || media.year) && (<dd>
          {media.year && (<><span className="badge bg-light text-secondary">{media.year}</span>{' '}</>)}
          {media.tag && (<span className="badge bg-secondary">{media.tag}</span>)}
        </dd>)}
        {media.subtitle && (<dd title={media.subtitle}>{media.subtitle}</dd>)}
      </dl>
    </div>
  );
};

export default MediaInfoLite;
